var $3be50edacdd1992b$exports = {};
$3be50edacdd1992b$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$3be50edacdd1992b$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
